import { useApi } from './use-api-call';

export const useSearchUsersApi = () =>
    useApi<{ list: UserDTO[]; allowEdit: boolean }>('/manage-users/search-users');
export const useGetUsersApi = () =>
    useApi<{ user: UserDTO }>('/manage-users/save-user?userName={userName}');
export const useSaveUsersApi = () => useApi<{ user: UserDTO }>('/manage-users/save-user');
export const useDeleteUsersApi = () => useApi('/manage-users/delete-user?userName={userName}');

export type UserDTO = {
    userName?: string;
    firstName?: string;
    displayName?: string;
    lastName?: string;
    passwordHash?: string;
    phoneNumber?: string;
    phoneNumberConfirmed?: boolean;
    accessFailedCount?: number;
    lastAccessFailedDate?: Date;
    addressSerial?: number;
    certificate?: string;
    defaultLanguage?: string;
    isServiceUser?: boolean;
    isDeleted?: boolean;
    isDisabled?: boolean;
    uniqueId?: string;
    imageAttachmentId?: number;
    lastUpdate?: Date;
    createdAt?: Date;
    authenticatorKey?: string;
    current2FA?: string;
    workPhoneNumber?: string;
};
